import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { Product } from '../models/product.model';
import { GLOBAL } from './global';
import { VariableService } from '../services/sharedVariables';

@Injectable()
export class ProductService{
   public url: string;
   public user_id:number;

   constructor(
     public _http: Http,
     public VariableService: VariableService
   )
   {
     this.url = GLOBAL.url;
     this.user_id = parseInt(this.VariableService.getCookie('user_id'));
   }

   getProducts()
   {
     return this._http.get(this.url+'products/'+this.user_id).map(res => res.json());
   }

   getProduct()
   {
     return "getProduct from service";
   }

   addProduct(product: Product)
   {
     let json = JSON.stringify(product);
     let params = 'json='+json;
     console.log(params);
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     return this._http.post(this.url+'add-product/'+this.user_id,params, {headers:headers}).map(res => res.json());

   }

   updateProduct(id:number,pProduct: Product)
   {
     let json = JSON.stringify(pProduct);
     let params = "json="+json;
     let headers = new Headers({'Content-Type':'application/x-www-form-urlencoded'});
     console.log(params);
     return this._http.post(this.url+'edit-product/'+id+'/'+this.user_id,params,{headers: headers})
                       .map(res => res.json());
   }

   deleteProduct(id:number)
   {
     return this._http.get(this.url+'delete-product/'+id+'/'+this.user_id)
                     .map(res => res.json());
   }
}



// WEBPACK FOOTER //
// /home/isai/funeraria/src/app/services/product.service.ts